'use strict';

/* eslint global-require: 0 */
module.exports = require('./Utils');


//////////////////
// WEBPACK FOOTER
// ./node_modules/enzyme-adapter-utils/build/index.js
// module id = 1285
// module chunks = 0